import type { PartyFormData } from "Components/Users/schemas";
import { LegalEntityFields } from "Components/Users/UserDetailPageContent/Components/PartyForm/LegalEntityFields/LegalEntityFields";
import { NaturalPersonFields } from "Components/Users/UserDetailPageContent/Components/PartyForm/NaturalPersonFields";
import { SelfEmployedFields } from "Components/Users/UserDetailPageContent/Components/PartyForm/SelfEmployedFields";
import type { PartyFormFieldsProps } from "Components/Users/UserDetailPageContent/Components/PartyForm/types";
import { type PartyDto, PartyType } from "Infrastructure/Api/Api";
import type { FC } from "react";
import type { DeepPartial } from "react-hook-form";

export const PARTY_TYPE_TO_FORM_FIELDS: Record<
  PartyType,
  FC<PartyFormFieldsProps>
> = {
  [PartyType.NaturalPerson]: NaturalPersonFields,
  [PartyType.LegalEntity]: LegalEntityFields,
  [PartyType.SelfEmployed]: SelfEmployedFields,
};

export const partyDtoToFormData = (
  party: PartyDto,
): DeepPartial<PartyFormData> => ({
  ...party,
  publicID: party.publicID ?? "",
  addresses: party.addresses.map((address) => ({
    ...address,
    municipality: address.municipality ?? undefined,
  })),
});
